// Inline Material Symbols icons for use inside <md-icon> (Material Web renders
// SVG children directly). Bundled at build time from @material-symbols, so only
// the icons actually used ship — no ~3 MB icon font, no external request.
import { html } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

import home from "@material-symbols/svg-400/outlined/home.svg?raw";
import inventory_2 from "@material-symbols/svg-400/outlined/inventory_2.svg?raw";
import group from "@material-symbols/svg-400/outlined/group.svg?raw";
import history from "@material-symbols/svg-400/outlined/history.svg?raw";
import description from "@material-symbols/svg-400/outlined/description.svg?raw";
import link from "@material-symbols/svg-400/outlined/link.svg?raw";
import attach_file from "@material-symbols/svg-400/outlined/attach_file.svg?raw";
import add from "@material-symbols/svg-400/outlined/add.svg?raw";
import shield from "@material-symbols/svg-400/outlined/shield.svg?raw";
import contactless from "@material-symbols/svg-400/outlined/contactless.svg?raw";
import verified from "@material-symbols/svg-400/outlined/verified.svg?raw";
import public_icon from "@material-symbols/svg-400/outlined/public.svg?raw";
import map from "@material-symbols/svg-400/outlined/map.svg?raw";
import location_on from "@material-symbols/svg-400/outlined/location_on.svg?raw";
import workspace_premium from "@material-symbols/svg-400/outlined/workspace_premium.svg?raw";
import arrow_forward from "@material-symbols/svg-400/outlined/arrow_forward.svg?raw";
import fingerprint from "@material-symbols/svg-400/outlined/fingerprint.svg?raw";
import dashboard from "@material-symbols/svg-400/outlined/dashboard.svg?raw";
import nfc from "@material-symbols/svg-400/outlined/nfc.svg?raw";
import groups from "@material-symbols/svg-400/outlined/groups.svg?raw";
import receipt_long from "@material-symbols/svg-400/outlined/receipt_long.svg?raw";
import schedule from "@material-symbols/svg-400/outlined/schedule.svg?raw";
import flag from "@material-symbols/svg-400/outlined/flag.svg?raw";
import edit from "@material-symbols/svg-400/outlined/edit.svg?raw";
import hourglass_empty from "@material-symbols/svg-400/outlined/hourglass_empty.svg?raw";
import search from "@material-symbols/svg-400/outlined/search.svg?raw";
import person_add from "@material-symbols/svg-400/outlined/person_add.svg?raw";
import delete_icon from "@material-symbols/svg-400/outlined/delete.svg?raw";
import add_circle from "@material-symbols/svg-400/outlined/add_circle.svg?raw";
import account_balance from "@material-symbols/svg-400/outlined/account_balance.svg?raw";
import factory from "@material-symbols/svg-400/outlined/factory.svg?raw";
import verified_user from "@material-symbols/svg-400/outlined/verified_user.svg?raw";
import gpp_bad from "@material-symbols/svg-400/outlined/gpp_bad.svg?raw";
import link_off from "@material-symbols/svg-400/outlined/link_off.svg?raw";
import local_shipping from "@material-symbols/svg-400/outlined/local_shipping.svg?raw";
import storefront from "@material-symbols/svg-400/outlined/storefront.svg?raw";
import travel_explore from "@material-symbols/svg-400/outlined/travel_explore.svg?raw";
import campaign from "@material-symbols/svg-400/outlined/campaign.svg?raw";
import domain from "@material-symbols/svg-400/outlined/domain.svg?raw";
import badge from "@material-symbols/svg-400/outlined/badge.svg?raw";
import hub from "@material-symbols/svg-400/outlined/hub.svg?raw";
import check_circle from "@material-symbols/svg-400/outlined/check_circle.svg?raw";
import mail from "@material-symbols/svg-400/outlined/mail.svg?raw";
import arrow_back from "@material-symbols/svg-400/outlined/arrow_back.svg?raw";
import menu from "@material-symbols/svg-400/outlined/menu.svg?raw";
import open_in_new from "@material-symbols/svg-400/outlined/open_in_new.svg?raw";
import download from "@material-symbols/svg-400/outlined/download.svg?raw";

const RAW: Record<string, string> = {
  home,
  inventory_2,
  group,
  history,
  description,
  link,
  attach_file,
  add,
  shield,
  contactless,
  verified,
  public: public_icon,
  map,
  location_on,
  workspace_premium,
  arrow_forward,
  fingerprint,
  dashboard,
  nfc,
  groups,
  receipt_long,
  schedule,
  flag,
  edit,
  hourglass_empty,
  search,
  person_add,
  delete: delete_icon,
  add_circle,
  account_balance,
  factory,
  verified_user,
  gpp_bad,
  link_off,
  local_shipping,
  storefront,
  travel_explore,
  campaign,
  domain,
  badge,
  hub,
  check_circle,
  mail,
  arrow_back,
  menu,
  open_in_new,
  download,
};

/**
 * Renders a Material Symbols icon as an <md-icon>. `name` must be one of the
 * keys above. Import "@material/web/icon/icon.js" wherever this is used.
 */
export function icon(name: keyof typeof RAW | string, ariaLabel?: string) {
  const svg = RAW[name];
  if (!svg) return html``;
  return html`<md-icon
    role=${ariaLabel ? "img" : "presentation"}
    aria-label=${ariaLabel ?? ""}
    aria-hidden=${ariaLabel ? "false" : "true"}
    >${unsafeHTML(svg)}</md-icon
  >`;
}
